import styled from 'styled-components';

export const ResultItem = styled.li`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  cursor: pointer;
  border-bottom: 1px solid ${({ theme }) => theme.colours.whiteSolid};
  transition: background-color 0.2s ease-in-out;
  font-family: 'Open Sans';
  font-size: ${({ theme }) => theme.pxToRem(14)};
  text-align: left;
  white-space: normal;
  overflow-wrap: break-word;
  line-height: 1.5;
  border-radius: ${({ theme }) => theme.pxToRem(6)};
  color: ${({ theme }) => theme.colours.charcoalDust};
  height: 40px;
  width: 100%;

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background-color: ${({ theme }) => theme.colours.whiteSolid};
  }
`;

export const ResultListContainer = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  max-height: 240px;
  overflow-y: auto;
  border: 1px solid #ddd;
  border-radius: 8px;
  background: white;
  box-shadow: 0 2px 8px rgb(0 0 0 / 10%);
  width: 100%;
`;
